import { render, staticRenderFns } from "./CustomizeUpgradeFeatures.vue?vue&type=template&id=02cb48a8&"
import script from "./CustomizeUpgradeFeatures.vue?vue&type=script&lang=js&"
export * from "./CustomizeUpgradeFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports